/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface VisitHoldingMergeViewModel {
  id?: string;
  referenceNumber?: number;
  balance?: number | null;
  fromDate?: string | null;
  primaryInsuranceName?: string | null;
  secondaryInsuranceName?: string | null;
  tertiaryInsuranceName?: string | null;
  financialClassName?: string | null;
  primaryInsuranceId?: string | null;
  secondaryInsuranceId?: string | null;
  tertiaryInsuranceId?: string | null;
  primaryInsuranceHoldingId?: string | null;
  secondaryInsuranceHoldingId?: string | null;
  tertiaryInsuranceHoldingId?: string | null;
  readonly formattedDate?: string | null;
  readonly outputLabel?: string | null;
}
